module.exports = __webpack_public_path__ + "img/emptyStateSearch.0ffddb67.svg";